import { Book } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from '../../../axios'
import assets from "../../../assets/assets";
import PdfQType from "./PdfQType";
import ConfirmPopup from "./ConfirmPopup";


function PublishedQListPreRead({
    publishPre_id,
    setIsPopupOpen,
    setSubmitPopup,
    setShowPreRead,
    preRead
}) {
    const [isGettingData, setIsGettingData] = useState(false);
    const [confirmPopUp, setConfirmPopUp] = useState(false);
    const userId = useSelector((state) => state.user?.currentUser?.id);
    const [homeMain, setHomeMain] = useState({
        preReadData: null,
        preReadStatus: null
    });
    const currentUser = useSelector((state) => state.user.currentUser);
    useEffect(() => {
        const pendingBox = async () => {
            setIsGettingData(true)
            try {
                let response = await axios.get(`homework/preRead/getById/${publishPre_id}`);
                let preReadStatus = await axios.get(`/preRead/studentStatus/preReadId/${publishPre_id}/studentId/${currentUser.id}`);
                console.log("response", response);

                response &&
                    setHomeMain((prev) => ({ ...prev, preReadData: response?.data?.data, preReadStatus: preReadStatus?.data?.data?.status }));
                setIsGettingData(false);
            } catch (error) {
                console.log(error);
                setIsGettingData(false);
            }
        };
        pendingBox();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (
        <div
            className="position-fixed top-0 start-0 w-full h-full d-flex justify-content-center align-items-center"
            style={{
                backgroundColor: "rgba(0,0,0,0.4)",
                zIndex: 9999,
            }}
        >
            <div
                className="rounded shadow relative"
                style={{
                    width: "90%",
                    maxWidth: "750px",
                    maxHeight: "500px",
                    minHeight: "480px",
                    overflowY: "auto",
                    backgroundColor: "#f3f3f3",
                }}
            >
                <img src={assets.CrossIcon} onClick={() => {
                    if (typeof setShowPreRead === 'function') {
                        setShowPreRead(false)
                    } else {
                        setIsPopupOpen(false)
                    }
                }} className="w-7 cursor-pointer absolute top-1 right-1" alt="crossicon" />
                {isGettingData ? (
                    <img className="w-40 m-auto" src="/gif/LoaderDot.gif" alt="Loading..." />
                ) : homeMain?.preReadData === null ? (
                    <div className="p-2">No Pre-read Found!!</div>
                ) : (
                    <div style={{ backgroundColor: "#fdefe4", height: "130px" }}>
                        {/* Header */}
                        <div className="p-4">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <div className="d-flex align-items-center gap-2">
                                    <Book size={20} />
                                    <h5 className="fw-bold m-0">
                                        {homeMain?.preReadData?.name}
                                    </h5>
                                </div>
                            </div>

                            {/* Subject + Status */}
                            <div className="d-flex align-items-center mb-3 gap-2 flex-wrap">
                                <span className="badge bg-light text-dark d-flex align-items-center">
                                    📘 {homeMain?.preReadData?.subject_id?.name}
                                </span>
                                <span className="badge bg-warning text-white">Published</span>
                            </div>
                        </div>

                        {/* Body */}
                        <div className="p-4" style={{ backgroundColor: "#f3f3f3", minHeight: "300px" }}>
                            <p
                                className="text-muted"
                                style={{ fontSize: "0.95rem", wordBreak: "break-word" }}
                            >
                                {homeMain?.preReadData?.description}
                            </p>

                            <hr />

                            {/* Attachments */}
                            {homeMain?.preReadData?.attachments?.length > 0 ? (
                                <div className="col-12">
                                    <h6 className="fw-semibold mt-4 mb-2">📎 Shared Files</h6>
                                    <div className="row">
                                        {homeMain?.preReadData?.attachments.map((attachment, idx) => (
                                            <div className="col-12 col-sm-6 col-md-4 mb-3" key={idx}>
                                                <PdfQType
                                                    attachData={homeMain?.preReadData}
                                                    attachment={attachment}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <div className="p-1">No Attachment!!</div>
                            )}
                        </div>

                        {/* Footer */}
                        {homeMain?.preReadStatus !== "completed" && (
                            <div className="p-2 d-flex justify-content-end">
                                <button
                                    className="btn prereadSubmit"
                                    onClick={() => setConfirmPopUp(true)}
                                >
                                    Mark Completed
                                </button>
                            </div>
                        )}
                    </div>
                )}

            </div >
            {confirmPopUp && <ConfirmPopup
                setConfirmPopUp={setConfirmPopUp}
                preread={homeMain?.preReadData}
                setIsPopupOpen={setIsPopupOpen}
                setShowPreRead={setShowPreRead}
                setSubmitPopup={setSubmitPopup}
            />}
        </div >
    )
}

export default PublishedQListPreRead;
